<template>
  <div class="rightTableDiv">
    <search-form
      ref="searchForm"
      class="searchFormDiv"
      @changeScrollY="changeScrollY"
      @clearSearch="clearSearch"
      @derive="derive"
      @saveAdvanced="saveAdvanced"
      @setSearchCondition="setSearchCondition"
      @showAssetHeadManage="showAssetHeadManage"
      @showEcharts="showEcharts"
      @showpredictTheOutcomeModules="showpredictTheOutcomeModules"></search-form>
    <!--    展开按钮放在表格内线是时需要用到，放在这以防止他们又喜欢改来改去-->
    <!--            expandRowByClick-->
    <!--            :expandIcon="expandIcon"-->
    <!--            :expandIconAsCell="false"-->
    <!--            :expandIconColumnIndex="3"-->
    <!--            :expandedRowKeys="expandedRowKeys"-->
    <!--    默认展开按钮-->
    <!--    @expand="showLine"-->
    <a-table
      id="assetTable"
      :columns="columns"
      :components="components"
      :customRow="changeRow"
      :dataSource="tableData.data"
      :expandIcon="expandIcon"
      :expandIconAsCell="false"
      :expandIconColumnIndex="3"
      :expandedRowKeys="expandedRowKeys"
      :loading="tableData.loading"
      :pagination="pagination"
      :row-selection="rowSelection"
      :rowClassName="rowClassName"
      :rowKey="record => record.id"
      :scroll="{ y: scrollY, x: 1050 }"
      bordered
      class="assetTable"
      expandRowByClick
      @change="handleTableChange">
      <template slot="icon" slot-scope="text, record">
        <div class="assetNameTable">
          <!--          展开按钮表格内显示-->
          <div class="expandBtn" @click="showLine(record)">
            <div v-if="expandedRowKeys[0] === text.id" aria-label="关闭行" class="ant-table-row-expand-icon ant-table-row-expanded" role="button" tabindex="0"></div>
            <div v-else aria-label="展开行" class="ant-table-row-expand-icon ant-table-row-collapsed" role="button" tabindex="0"></div>
          </div>
        </div>
      </template>
      <template slot="txt50" slot-scope="text, record">
        <div class="textAlign-Left">
          <span>{{ record.txt50 }}</span>
          <!--          <a-tooltip>-->
          <!--            <template slot="title">{{ record.txt50 }}</template>-->
          <!--            <span class="txt50Span">{{ record.txt50 }}</span>-->
          <!--          </a-tooltip>-->
        </div>
      </template>
      <template slot="url" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.url }}</template>
            <span class="txt50Span">{{ record.url }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="assetNumber" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.assetNumber }}</template>
            <span class="txt50Span">{{ record.assetNumber }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="disposalStatus" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.disposalStatus }}</template>
            <span class="txt50Span">{{ record.disposalStatus }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="raumn" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.raumn }}</template>
            <span class="txt50Span">{{ record.raumn }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="kansw" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ykansw }}</template>
            <span class="txt50Span">{{ record.kansw }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="qmjz" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.yqmjz }}</template>
            <span class="txt50Span">{{ record.qmjz }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="txk20" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.txk20 }}</template>
            <span class="txt50Span">{{ record.txk20 }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="departmentname" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.departmentname }}</template>
            <span class="txt50Span">{{ record.departmentname }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="anlkl" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.anlkl }}</template>
            <span class="txt50Span">{{ record.anlkl }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="ndjar" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ndjar }}</template>
            <span class="txt50Span">{{ record.ndjar }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="anln1" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.anln1 }}</template>
            <span class="txt50Span">{{ record.anln1 }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="sernr" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.sernr }}</template>
            <span class="txt50Span">{{ record.sernr }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="ebeln" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ebeln }}</template>
            <span class="txt50Span">{{ record.ebeln }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="lifnrName" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.lifnrName }}</template>
            <span class="txt50Span">{{ record.lifnrName }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="aktiv" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.aktiv }}</template>
            <span class="txt50Span">{{ record.aktiv }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="zugdt" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.zugdt }}</template>
            <span class="txt50Span">{{ record.zugdt }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="deakt" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.deakt }}</template>
            <span class="txt50Span">{{ record.deakt }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="ordtx41" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ordtx41 }}</template>
            <span class="txt50Span">{{ record.ordtx41 }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="gdlgrpTxt" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.gdlgrpTxt }}</template>
            <span class="txt50Span">{{ record.gdlgrpTxt }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="ordtx42" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ordtx42 }}</template>
            <span class="txt50Span">{{ record.ordtx42 }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="herst" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.herst }}</template>
            <span class="txt50Span">{{ record.herst }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="lifnr" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.lifnr }}</template>
            <span class="txt50Span">{{ record.lifnr }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="txa50" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.txa50 }}</template>
            <span class="txt50Span">{{ record.txa50 }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="assetConstructionStatus" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.assetConstructionStatus }}</template>
            <span class="greenIcon padding-4-8 txt50Span" v-if="record.assetConstructionStatus === '新建'">{{ record.assetConstructionStatus }}</span>
            <span class="blueIcon padding-4-8 txt50Span" v-else-if="record.assetConstructionStatus === '在用' || record.assetConstructionStatus === '已处置'">{{ record.assetConstructionStatus }}</span>
            <span class="orangeIcon padding-4-8 txt50Span" v-else>{{ record.assetConstructionStatus }}</span>
            <!--            <span class="txt50Span">{{ record.assetConstructionStatus }}</span>-->
          </a-tooltip>
        </div>
      </template>
      <template slot="ord43" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ord43 }}</template>
            <span class="txt50Span">{{ record.ord43 }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="ordtx" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ordtx }}</template>
            <span class="txt50Span">{{ record.ordtx }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="expandedRowRender" slot-scope="record">
        <div class="expand_row">
          <!-- 占位 -->
          <div :style="{width: toLeftWidth}" class="expand_left"></div>
          <!-- 展开显示的内容 -->
          <div class="expand_right">
            <data-tabs ref="dataTabs" :model="expandedRowKeys[0] === record.id ? record : null" :subcompanyid="assetCompanyId.id"></data-tabs>
          </div>
        </div>
      </template>
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click.stop="() => handleEdit(record)">发起流程</a>
      </template>
      <template slot="footer">
        <div class="footerDiv">
          <div class="footerDiv">
            <span class="totalNumDiv">
              <span>总资产数量：</span>
              <span>{{ tableData.statistics.mengeSum ? tableData.statistics.mengeSum : 0 }}</span>
            </span>
          </div>
          <div class="footerDiv">
            <span class="totalNumDiv">
              <span>查询总条数：</span>
              <span>{{ pagination.total ? pagination.total : 0 }}条</span>
            </span>
          </div>
          <div class="footerDiv">
            <span class="totalNumDiv">
              <span>总资产购置价值总和：</span>
              <span>{{ tableData.statistics.kanswSum ? tableData.statistics.kanswSum : 0 }}</span>
            </span>
          </div>
          <div class="footerDiv">
            <span class="totalNumDiv">
              <span>总资产现值总和：</span>
              <span>{{ tableData.statistics.qmjzSum ? tableData.statistics.qmjzSum : 0 }}</span>
            </span>
          </div>
        </div>
      </template>
    </a-table>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="derive()">导出当前台账</li>
    </ul>
    <drawer-export ref="drawerExport"></drawer-export>
    <echarts-modules ref="echartsModules" :searchModel="searchModel"></echarts-modules>
    <predict-the-outcome-modules ref="predictTheOutcomeModules"></predict-the-outcome-modules>
    <asset-head-manage ref="assetHeadManage" @retrievesTheTableHeader="retrievesTheTableHeader"></asset-head-manage>
  </div>
</template>
<script>
import SearchForm from '@/views/assetLedger/modules/searchForm'
import { getAssetTableData, getAssetTableTotal, getDeptTreeList } from '@/api/assetLedger'
import { getAssetTypeField } from '@/api/assetHeadManage'
import DataTabs from './detailModules/dataTabs.vue'
import drawerExport from '@/views/assetLedger/modules/drawerExportSecond'
import { getTableScroll } from '@/views/assetLedger/modules/height'
import { mapGetters } from 'vuex'
// import tableDragResize from '../../../mixins/tableDragResize'
import tableDrag from '../../../mixins/tableDrag'
import moment from 'moment'
import EchartsModules from '@/views/assetLedger/modules/echartsModules/echartsModules'
import predictTheOutcomeModules from '@/views/assetLedger/modules/echartsModules/predictTheOutcomeModules'
import assetHeadManage from '@/views/assetLedger/modules/assetHeadManage/assetHeadManage'
import Vue from 'vue'
export default {
  name: 'TableData',
  mixins: [tableDrag], // 此处不要忘记
  components: {
    EchartsModules,
    drawerExport,
    DataTabs,
    SearchForm,
    predictTheOutcomeModules,
    assetHeadManage
  },
  computed: {
    ...mapGetters(['assetCompanyId', 'assetAnlkl']),
    columns: {
      get () {
        let { sortedInfo } = this
        sortedInfo = sortedInfo || {}
        this.columnsData.forEach(item => {
          if (item.sortOrNot) {
            item.sorter = (a, b) => {}
            item.sortOrder = sortedInfo.columnKey === item.dataIndex && sortedInfo.order
          }
          item.align = 'center'
        })
        return this.columnsData
      },
      set (newValue) {
        this.columnsData = newValue
      }
    }
  },
  data () {
    this.components = {
      header: {
        cell: this.resizeableTitle
      }
    }
    return {
      columnsData: [],
      originalTableHead: [
        {
          title: '',
          scopedSlots: {
            customRender: 'icon'
          },
          align: 'center',
          width: 35
        },
        {
          title: '序号',
          customRender: (text, record, index) => {
            return index + 1
          },
          align: 'center',
          width: 35
          // customHeaderCell: column => {
          //   return {
          //     style: {
          //       'width': '58px',
          //       'max-width': '58px'
          //     }
          //   }
          // },
        },
        {
          title: '资产描述',
          dataIndex: 'txt50',
          scopedSlots: {
            customRender: 'txt50'
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'txt50' && sortedInfo.order,
          align: 'center',
          width: 170
        },
        {
          title: '所属公司',
          dataIndex: 'url',
          scopedSlots: {
            customRender: 'url'
          },
          align: 'center',
          width: 70
        },
        {
          title: '资产编号',
          dataIndex: 'assetNumber',
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'assetNumber' && sortedInfo.order,
          align: 'center',
          width: 85
        },
        {
          title: '资产分类',
          dataIndex: 'txk20',
          scopedSlots: {
            customRender: 'txk20'
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'txk20' && sortedInfo.order,
          align: 'center',
          width: 70
        },
        {
          title: '资产状态',
          dataIndex: 'assetConstructionStatus',
          scopedSlots: {
            customRender: 'assetConstructionStatus'
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'ordtx' && sortedInfo.order,
          align: 'center',
          width: 70
        },
        {
          title: '归口部门',
          dataIndex: 'ordtx',
          scopedSlots: {
            customRender: 'ordtx'
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'ordtx' && sortedInfo.order,
          align: 'center',
          width: 70
        },
        {
          title: '使用部门',
          dataIndex: 'departmentname',
          scopedSlots: {
            customRender: 'departmentname'
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'departmentname' && sortedInfo.order,
          align: 'center',
          width: 70
        },
        // {
        //   title: '责任人',
        //   dataIndex: 'raumn',
        //   scopedSlots: {
        //     customRender: 'raumn'
        //   },
        //   // sorter: (a, b) => {},
        //   sortOrNot: true,
        //   // sortOrder: sortedInfo.columnKey === 'raumn' && sortedInfo.order,
        //   align: 'center',
        //   width: 55
        // },
        {
          title: '资产现值/万元',
          dataIndex: 'qmjz',
          scopedSlots: {
            customRender: 'qmjz'
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'qmjz' && sortedInfo.order,
          align: 'center',
          width: 70
        },
        {
          title: '资产购置价值/万元',
          dataIndex: 'kansw',
          scopedSlots: {
            customRender: 'kansw'
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'kansw' && sortedInfo.order,
          align: 'center',
          width: 75
        },
        {
          title: '投用日期',
          dataIndex: 'aktiv',
          customRender: (text, record, index) => {
            return record.aktiv ? moment(record.aktiv).format('YYYY-MM-DD') : ''
          },
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'ndjar' && sortedInfo.order,
          align: 'center',
          width: 75
        },
        {
          title: '资产使用年限',
          dataIndex: 'ndjar',
          // sorter: (a, b) => {},
          sortOrNot: true,
          // sortOrder: sortedInfo.columnKey === 'ndjar' && sortedInfo.order,
          align: 'center',
          width: 65
        }
      ],
      searchValue: '',
      // 表格数据
      tableData: {
        data: [],
        statistics: {
          mengeSum: 0,
          kanswSum: 0,
          qmjzSum: 0
        },
        loading: {
          spinning: false,
          tip: '加载中...'
        }
      },
      sortedInfo: null,
      scrollY: 0,
      toLeftWidth: 0,
      advanced: false,
      isFirst: true,
      // 搜索条件
      searchModel: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sort: {},
      // 展开的行
      expandedRowKeys: [],
      // 选中的行
      selectedRows: [],
      rowSelection: {
        columnWidth: 30,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      // 左侧树的搜索条件
      treeSearchModel: {},
      visible: false,
      top: 0,
      left: 0,
      selectedRowsData: {}
    }
  },
  created () {
    this.originalTableHead.forEach(item => {
      if (item.title === '投用日期' || item.title === '首次购置日期') {
        item.customRender = (text, record, index) => {
          return record[item.dataIndex] ? moment(record[item.dataIndex]).format('YYYY-MM-DD') : ''
        }
        delete item.scopedSlots
      }
    })
    this.columns = this.originalTableHead
    // 获取表格数据
    // 获取资产统计
    // this.getAssetTotal()
  },
  mounted () {

  },
  watch: {
    assetCompanyId (newValue) {
      this.searchModel = this.$refs.searchForm.search('returnModel')
      if (newValue.id !== '') {
        if (newValue.id === '空' || newValue.id === '杭氧') {
          delete this.treeSearchModel.comid
          delete this.searchModel.comid
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading.spinning = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
          this.tableData.statistics = {
            mengeSum: 0,
            kanswSum: 0,
            qmjzSum: 0
          }
        } else {
          this.treeSearchModel.comid = newValue.id
        }
      } else {
        delete this.treeSearchModel.comid
      }
      delete this.searchModel.comid
      if (newValue.id !== '空') {
        this.setSearchCondition(this.searchModel)
      }
    },
    assetAnlkl (newValue) {
      this.searchModel = this.$refs.searchForm.search('returnModel')
      if (newValue.anlklCodeList !== [] && newValue.anlkl !== '资产分类') {
        if (newValue.anlkl === '空') {
          delete this.treeSearchModel.anlklList
          delete this.searchModel.anlklList
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading.spinning = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
          this.tableData.statistics = {
            mengeSum: 0,
            kanswSum: 0,
            qmjzSum: 0
          }
        } else {
          this.treeSearchModel.anlklList = newValue.anlklCodeList
          const query = {
            typeCode: newValue.anlkl,
            type: 3
          }
          getAssetTypeField(query).then(res => {
            if (res.status === 0) {
              if (res.data.length > 0) {
                res.data.unshift(
                  {
                    title: '',
                    scopedSlots: {
                      'customRender': 'icon'
                    },
                    align: 'center',
                    customCell: column => {
                      return {
                        style: {
                          'width': '35px',
                          'max-width': '35px'
                        }
                      }
                    },
                    width: 35
                  },
                  {
                    title: '序号',
                    customRender: (text, record, index) => {
                      return index + 1
                    },
                    align: 'center',
                    customCell: column => {
                      return {
                        style: {
                          'width': '35px',
                          'max-width': '35px'
                        }
                      }
                    },
                    width: 35
                  }
                )
                res.data.forEach(item => {
                  if (item.isDate) {
                    item.customRender = (text, record, index) => {
                      return record[item.dataIndex] ? moment(record[item.dataIndex]).format('YYYY-MM-DD') : ''
                    }
                    delete item.scopedSlots
                  }
                })
                this.columns = res.data
                // 修改这里
                this.columns.forEach(col => {
                  this.draggingMap[col.dataIndex || col.key] = col.width
                })
                this.draggingState = Vue.observable(this.draggingMap)
                // tableDrag.methods.drag(this.columns)
              } else {
                this.columns = this.originalTableHead
              }
            } else {
              this.columns = this.originalTableHead
              this.$message.error(res.info.message)
            }
          }).catch(err => {
            this.$message.error(err.info.message)
          })
        }
      } else {
        this.columns = this.originalTableHead
        delete this.treeSearchModel.anlklList
      }
      delete this.searchModel.anlklList
      if (newValue.anlkl !== '空' && !this.isFirst) {
        console.log(true)
        this.setSearchCondition(this.searchModel)
      }
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    // 隐藏展开图标
    expandIcon (props) {
      return null
    },
    // 计算宽度
    calculativeWidth () {
      this.$nextTick(() => {
        const firstTableHeader = document.querySelector('.ant-table-selection-column').offsetWidth
        const secondTableHeader = document.querySelector('.ant-table-align-center').offsetWidth
        this.toLeftWidth = firstTableHeader + secondTableHeader + 1 + 'px'
      })
    },
    // 判断是否展开行
    showLine (expanded, record) {
      this.$nextTick(() => {
        const firstTableHeader = document.querySelector('.ant-table-selection-column').offsetWidth
        const secondTableHeader = document.querySelector('.ant-table-align-center').offsetWidth
        this.toLeftWidth = firstTableHeader + secondTableHeader + 1 + 'px'
      })
      // 只展开一行
      if (this.expandedRowKeys.length > 0) { // 进这个判断说明当前已经有展开的了
        // 返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        const index = this.expandedRowKeys.indexOf(expanded.id)
        if (index > -1) { // 如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1)
        } else {
          // 如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
          this.expandedRowKeys.push(expanded.id)
        }
      } else {
        // 数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(expanded.id)
      }
    },
    rowClassName (record, index) {
      let className = ''
      if (index % 2 === 1) {
        className = 'evenNumberedDisplay '
      } else {
        className = ''
      }
      if (record.id === this.expandedRowKeys[0]) {
        className += 'activeHighLight'
      }
      return className
    },
    // 改变scrollY
    changeScrollY (extraHeight, type) {
      this.$nextTick(() => {
        this.scrollY = getTableScroll(extraHeight, 'assetTable', type)
        const dom = document.getElementById('assetTable')
        if (type === 'addAssetTableHeigth') {
          dom.classList.add('assetTableHeight_126')
        } else {
          dom.classList.remove('assetTableHeight_126')
        }
      })
    },
    // 保存展开状态字段
    saveAdvanced (advanced) {
      this.advanced = advanced
    },
    // 获取表格数据
    getTableData (type) {
      this.searchModel = { ...this.searchModel, ...this.pagination, ...this.sort }
      this.expandedRowKeys = []
      if (this.searchModel.historyMonth) {
        this.searchModel.year = Number(moment(this.searchModel.historyMonth).format('YYYY'))
        this.searchModel.month = moment(this.searchModel.historyMonth).format('MM')
        this.tableData.loading.tip = '历史年份查询速度较慢，请耐心等待查询'
      } else {
        this.tableData.loading.tip = ''
      }
      this.tableData.loading.spinning = true
      getAssetTableData(this.searchModel).then(res => {
        if (res.status === 0) {
          if (res.data.list.length > 0) {
            for (let i = 0; i < res.data.list.length; i++) {
              const item = res.data.list[i]
              item.id = i
            }
          } else {
          }
          this.tableData.data = res.data.list
          this.pagination.total = res.data.total
          this.tableData.loading.spinning = false
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
        } else {
          this.tableData.data = []
          this.tableData.total = 0
          this.tableData.loading.spinning = false
          this.$message.error(res.info.message)
        }
      })
      // 获取资产统计
      this.getAssetTotal()
    },
    // 获取资产统计
    getAssetTotal () {
      if (this.searchModel.historyMonth) {
        this.searchModel.year = Number(moment(this.searchModel.historyMonth).format('YYYY'))
        this.searchModel.month = moment(this.searchModel.historyMonth).format('MM')
      }
      getAssetTableTotal(this.searchModel).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.tableData.statistics = res.data
          } else {
            this.tableData.statistics = {
              mengeSum: 0,
              kanswSum: 0,
              qmjzSum: 0
            }
          }
        }
      })
    },
    // 搜索
    setSearchCondition (searchModel) {
      this.isFirst = false
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel }
      this.getTableData()
    },
    // 导出
    derive (searchModel) {
      const setSearchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel, ...this.sort }
      this.$refs.drawerExport.setTitle('导出')
      this.$refs.drawerExport.setModel(setSearchModel)
      this.$refs.drawerExport.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.drawerExport.open(true)
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData()
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      if (sorter.field === 'ordtx') {
        this.sort.sortName = 'ord43'
      } else if (sorter.field === 'txk20') {
        this.sort.sortName = 'anlkl'
      } else if (sorter.field === 'txt50') {
        this.sort.sortName = 'txt50'
      } else {
        this.sort.sortName = sorter.field
      }
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
        delete this.searchModel.sortName
        delete this.searchModel.sortType
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData('changePageNum')
    },
    // 关闭右键菜单
    closeMenu () {
      this.visible = false
    },
    // 行点击
    changeRow (record) {
      return {
        on: {
          contextmenu: (e) => {
            e.preventDefault()
            e.stopPropagation()
            this.$emit('closeMenu', 'rightTable')
            var x = e.pageX - 239//  - 239
            var y = e.pageY - 41//
            this.top = y
            this.left = x
            this.selectedRowsData = record
            this.visible = true
          }
        }
      }
    },
    // 打开图表弹窗
    showEcharts (model) {
      this.$refs.echartsModules.open(true)
      this.$refs.echartsModules.setSearchModel(model)
    },
    // 打开预测折旧结果弹窗
    showpredictTheOutcomeModules (model) {
      this.$refs.predictTheOutcomeModules.open(true)
      this.$refs.predictTheOutcomeModules.setSearchModel(model)
    },
    // 打开资产表头配置弹窗
    showAssetHeadManage () {
      this.$refs.assetHeadManage.open()
    },
    // 判断是否需要重新获取表头
    retrievesTheTableHeader (list) {
      if (list.findIndex(item => item === this.assetAnlkl.anlkl) >= 0) {
        const query = {
          typeCode: this.assetAnlkl.anlkl,
          type: 3
        }
        getAssetTypeField(query).then(res => {
          if (res.status === 0) {
            if (res.data.length > 0) {
              res.data.unshift(
                {
                  title: '',
                  scopedSlots: {
                    'customRender': 'icon'
                  },
                  align: 'center',
                  customCell: column => {
                    return {
                      style: {
                        'width': '35px',
                        'max-width': '35px'
                      }
                    }
                  },
                  width: 35
                },
                {
                  title: '序号',
                  customRender: (text, record, index) => {
                    return index + 1
                  },
                  align: 'center',
                  customCell: column => {
                    return {
                      style: {
                        'width': '35px',
                        'max-width': '35px'
                      }
                    }
                  },
                  width: 35
                }
              )
              res.data.forEach(item => {
                if (item.isDate) {
                  item.customRender = (text, record, index) => {
                    return record[item.dataIndex] ? moment(record[item.dataIndex]).format('YYYY-MM-DD') : ''
                  }
                  delete item.scopedSlots
                }
              })
              this.columns = res.data
            } else {
              this.columns = this.originalTableHead
            }
          } else {
            this.columns = this.originalTableHead
            this.$message.error(res.info.message)
          }
        }).catch(err => {
          this.$message.error(err.info.message)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.rightTableDiv {
  height: 100%;
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
/deep/.ant-table-footer {
  padding: 0 !important;
  height: 40px;
  .footerDiv {
    display: grid;
    grid-template-columns: repeat(4, calc((100% - 12px)/ 4));
    grid-column-gap: 2px;
    flex-direction: row;
    //justify-content: space-between;
    background-color: #FFFFFF;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    .footerDiv {
      height: 100%;
      display: flex;
      flex-direction: row;
      //justify-content: center;
      align-items: center;
      padding: 0 20px;
      color: #333333;
      background-color: #C8EEED;
      font-weight: 500;
      span:first-child {
        //margin-right: 20px;
      }
    }
  }
}
/deep/.ant-table-expanded-row{
  >td{
    padding: 0;
    .expand_row{
      display: flex;
      .expand_left{
        width: 80px;
        border-right: 1px solid #e8e8e8;
        // 线颜色修改
        //border-right: 1px solid #bbbbbb;
        //background-color: #eeeeee;
      }
      .expand_right{
        width: calc(100% - 80px);
        //padding: 0 10px 8px 10px;
      }
    }
  }
}
// /deep/.ant-table-pagination.ant-pagination {
//   margin: 10px 0 0 0 !important;
// }
/deep/.assetTable  {
  transition: height 300ms ease;
  height: calc(100% - 42px);
  >.ant-spin-nested-loading {
    height: 100%;
    >.ant-spin-container {
      height: calc(100% - 43px);
      .ant-table {
        height: 100%;
        .ant-table-content {
          height: 100%;
          .ant-table-scroll{
            height: 100%;
            .ant-table-body {
              transition: max-height 300ms ease;
              height: calc(100% - 80px);
            }
          }
        }
      }
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: none;
          border-left: none;
        }
        .ant-table-thead > tr > th{
          border-right: none;
        }
        .ant-table-body > table{
          border-top: none;
          border-left: none;
        }
        .ant-table-tbody > tr > td{
          border-right: none;
          border-bottom: none;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
      >.ant-table-pagination.ant-pagination {
        margin: 10px 0 0 0 !important;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    margin: 10px;
  }
}
///deep/.ant-divider {
//  background-color: #bbbbbb !important;
//}
.assetTableHeight_126 {
  height: calc(100% - 126px) !important;
}
.textAlign-Left {
  text-align: left;
}
.assetNameTable {
  .txt50Span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  //width: 100%;
  //display: flex;
  //flex-direction: row;
  //align-items: center;
  .expandBtn {
    //margin-right: 5px;
  }
}
.blueBtn {
  background: rgba(23, 145, 255, 0.1) !important;
  color: #1791FF;
  border: 1px solid rgba(23, 145, 255, 0.7) !important;
}
.orangeBtn {
  background: rgba(255, 142, 59, 0.1) !important;
  color: #FF8E3B;
  border: 1px solid rgba(255, 142, 59, 0.7) !important;
}
.greenBtn {
  background: rgba(54, 191, 125, 0.1) !important;
  color: #36BF7D;
  border: 1px solid rgba(54, 191, 125, 0.7) !important;
}
/deep/.ant-table-align-center {
  padding: 0 !important;
}
/deep/.ant-table-body-max-height-0 {
  //max-height: 0 !important;
}
/deep/.ant-table-tbody .activeHighLight{
  background-color: #E7F4FF !important;
}
/deep/.ant-table-tbody .evenNumberedDisplay{
  background-color: rgba(231, 244, 255, 0.7) !important;
}
/deep/.ant-table-tbody > tr:hover > td {
  background-color: rgba(255,255,255,0) !important;
}
/deep/.ant-table-placeholder {
  position: absolute;
  background: none;
  border-top: none;
  border-bottom: none;
  border-radius: 0 0 4px 4px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 100px;
  .ant-empty-normal {
    margin: 0 !important;
  }
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: #eee;
}
.blueIcon,.orangeIcon,.greenIcon {
  margin-right: 5px;
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
}
.blueIcon {
  background: rgba(23,145,255,0.1);
  border: 1px solid rgba(23,145,255,0.7);
  color: #1791FF;
}
.orangeIcon {
  background: rgba(255, 142, 59, 0.10);
  border: 1px solid rgba(255, 142, 59, 0.70);
  color: rgba(255, 142, 59, 1);
}
.greenIcon {
  background: rgba(54, 191, 125, 0.10);
  border: 1px solid rgba(54, 191, 125, 0.70);
  color: rgba(54, 191, 125, 1);
}
.padding-4-8 {
  padding: 4px 8px !important;
}
/deep/.table-draggable-handle {
  border:1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/deep/.resize-table-th {
  position: relative;
}
</style>
